import upperFirst from 'lodash/upperFirst';
import isString from 'lodash/isString';

import Api from '@catalytic/pushbot-ui/SvgIcon/Api';
import Assignment from '@catalytic/pushbot-ui/SvgIcon/Assignment';
import Autodesk from '@catalytic/pushbot-ui/SvgIcon/Autodesk';
import AutomationAnywhere from '@catalytic/pushbot-ui/SvgIcon/AutomationAnywhere';
import Box from '@catalytic/pushbot-ui/SvgIcon/Box';
import Brain from '@catalytic/pushbot-ui/SvgIcon/Brain';
import Calendar from '@catalytic/pushbot-ui/SvgIcon/Calendar';
import CircleCI from '@catalytic/pushbot-ui/SvgIcon/CircleCI';
import Coupa from '@catalytic/pushbot-ui/SvgIcon/Coupa';
import Company from '@catalytic/pushbot-ui/SvgIcon/Company';
import CloudDownload from '@catalytic/pushbot-ui/SvgIcon/CloudDownload';
import CloudUpload from '@catalytic/pushbot-ui/SvgIcon/CloudUpload';
import CSV from '@catalytic/pushbot-ui/SvgIcon/CSV';
import Dayforce from '@catalytic/pushbot-ui/SvgIcon/Dayforce';
import DocuSign from '@catalytic/pushbot-ui/SvgIcon/DocuSign';
import DropBox from '@catalytic/pushbot-ui/SvgIcon/Dropbox';
import Excel from '@catalytic/pushbot-ui/SvgIcon/Excel';
import Ephesoft from '@catalytic/pushbot-ui/SvgIcon/Ephesoft';
import Eye from '@catalytic/pushbot-ui/SvgIcon/Eye';
import Face from '@catalytic/pushbot-ui/SvgIcon/Face';
import Fieldglass from '@catalytic/pushbot-ui/SvgIcon/Fieldglass';
import FileIcon from '@catalytic/pushbot-ui/SvgIcon/File';
import Github from '@catalytic/pushbot-ui/SvgIcon/Github';
import Gmail from '@catalytic/pushbot-ui/SvgIcon/Gmail';
import GoogleAnalytics from '@catalytic/pushbot-ui/SvgIcon/GoogleAnalytics';
import GoogleBigQuery from '@catalytic/pushbot-ui/SvgIcon/BigQuery';
import GoogleCalendar from '@catalytic/pushbot-ui/SvgIcon/GoogleCalendar';
import GoogleDrive from '@catalytic/pushbot-ui/SvgIcon/GoogleDrive';
import GoogleSheets from '@catalytic/pushbot-ui/SvgIcon/GoogleSheets';
import Quickbooks from '@catalytic/pushbot-ui/SvgIcon/Quickbooks';
import I9Advantage from '@catalytic/pushbot-ui/SvgIcon/I9Advantage';
import Jira from '@catalytic/pushbot-ui/SvgIcon/Jira';
import JobDiva from '@catalytic/pushbot-ui/SvgIcon/JobDiva';
import Images from '@catalytic/pushbot-ui/SvgIcon/Images';
import Invoices from '@catalytic/pushbot-ui/SvgIcon/Invoices';
import Kafka from '@catalytic/pushbot-ui/SvgIcon/Kafka';
import List from '@catalytic/pushbot-ui/SvgIcon/FormatListBulleted';
import Lever from '@catalytic/pushbot-ui/SvgIcon/Lever';
import LocationOn from '@catalytic/pushbot-ui/SvgIcon/LocationOn';
import Mail from '@catalytic/pushbot-ui/SvgIcon/Mail';
import ManualStart from '@catalytic/pushbot-ui/SvgIcon/ManualStart';
import MediaoceanPrisma from '@catalytic/pushbot-ui/SvgIcon/MediaoceanPrisma';
import Message from '@catalytic/pushbot-ui/SvgIcon/Message';
import Microsoft from '@catalytic/pushbot-ui/SvgIcon/Microsoft';
import MicrosoftDynamics from '@catalytic/pushbot-ui/SvgIcon/MicrosoftDynamics';
import NavDataMagnetic from '@catalytic/pushbot-ui/SvgIcon/Nav/NavDataMagnetic';
import Netsuite from '@catalytic/pushbot-ui/SvgIcon/Netsuite';
import Numbers from '@catalytic/pushbot-ui/SvgIcon/Numbers';
import Okta from '@catalytic/pushbot-ui/SvgIcon/Okta';
import OracleSalesCloud from '@catalytic/pushbot-ui/SvgIcon/OracleSalesCloud';
import Oracle from '@catalytic/pushbot-ui/SvgIcon/Oracle';
import Outlook from '@catalytic/pushbot-ui/SvgIcon/Outlook';
import Paylocity from '@catalytic/pushbot-ui/SvgIcon/Paylocity';
import Pdf from '@catalytic/pushbot-ui/SvgIcon/Pdf';
import Pipedrive from '@catalytic/pushbot-ui/SvgIcon/PipeDrive';
import PowerBI from '@catalytic/pushbot-ui/SvgIcon/PowerBI';
import PowerPoint from '@catalytic/pushbot-ui/SvgIcon/PowerPoint';
import Pushbot from '@catalytic/pushbot-ui/SvgIcon/Pushbot';
import Public from '@catalytic/pushbot-ui/SvgIcon/Public';
import S3 from '@catalytic/pushbot-ui/SvgIcon/S3';
import Salesforce from '@catalytic/pushbot-ui/SvgIcon/SalesForce';
import Sentiment from '@catalytic/pushbot-ui/SvgIcon/Sentiment';
import ServiceNow from '@catalytic/pushbot-ui/SvgIcon/ServiceNow';
import Sharepoint from '@catalytic/pushbot-ui/SvgIcon/Sharepoint';
import Slack from '@catalytic/pushbot-ui/SvgIcon/Slack/SlackMarkWeb';
import Sterling from '@catalytic/pushbot-ui/SvgIcon/Sterling';
import Stripe from '@catalytic/pushbot-ui/SvgIcon/Stripe';
import SuccessFactors from '@catalytic/pushbot-ui/SvgIcon/SuccessFactors';
import Sso from '@catalytic/pushbot-ui/SvgIcon/Sso';
import Text from '@catalytic/pushbot-ui/SvgIcon/Text';
import Trello from '@catalytic/pushbot-ui/SvgIcon/Trello';
import Trigger from '@catalytic/pushbot-ui/SvgIcon/Trigger';
import UiPath from '@catalytic/pushbot-ui/SvgIcon/UiPath';
import Web from '@catalytic/pushbot-ui/SvgIcon/Web';
import Word from '@catalytic/pushbot-ui/SvgIcon/Word';
import Workday from '@catalytic/pushbot-ui/SvgIcon/Workday';
import Wrike from '@catalytic/pushbot-ui/SvgIcon/Wrike';
import Xml from '@catalytic/pushbot-ui/SvgIcon/Xml';
import YouTube from '@catalytic/pushbot-ui/SvgIcon/YouTube';
import Zendesk from '@catalytic/pushbot-ui/SvgIcon/Zendesk';
import Zoom from '@catalytic/pushbot-ui/SvgIcon/Zoom';
import Handlebars from '@catalytic/pushbot-ui/SvgIcon/Handlebars';

// TODO API should return associated icon data
export function appNameToIcon(appName, appID) {
  if (isString(appID) && !appName) {
    appName = appID.split('/')[0];
  }
  switch (appName) {
    case 'automation-anywhere':
      return AutomationAnywhere;
    case 'autodesk':
      return Autodesk;
    case 'aws':
      return Assignment;
    case 'azure':
    case 'azure-blobstorage':
      return Microsoft;
    case 'box':
      return Box;
    case 'circleci':
      return CircleCI;
    case 'cognitive':
      return Brain;
    case 'coupa':
      return Coupa;
    case 'csv':
      return CSV;
    case 'dates':
      return Calendar;
    case 'dayforce':
      return Dayforce;
    case 'docusign':
      return DocuSign;
    case 'dropbox':
      return DropBox;
    case 'email':
      return Mail;
    case 'ephesoft':
      return Ephesoft;
    case 'excel':
      return Excel;
    case 'field':
      return Handlebars;
    case 'fieldglass':
      return Fieldglass;
    case 'files':
      return FileIcon;
    case 'fullcontact':
      switch (appID) {
        case 'fullcontact/company-lookup/v1':
          return Company;
        default:
          return Face;
      }
    case 'github':
      return Github;
    case 'gmail':
      return Gmail;
    case 'google-api':
      switch (appID) {
        case 'google-api/detect-language/v1':
          return Public;
        case 'google-api/sentiment/v1':
          return Sentiment;
        case 'google-api/vision/v1':
          return Eye;
        case 'google-api/vision/v2':
          return Eye;
        default:
          return Trigger;
      }
    case 'google-analytics':
      return GoogleAnalytics;
    case 'google-bigquery':
      return GoogleBigQuery;
    case 'google-calendar':
      return GoogleCalendar;
    case 'google':
      switch (appID) {
        case 'google-sheets/append/v1':
        case 'google/append/v1':
          return GoogleSheets;
        case 'google/detect-language/v1':
          return Public;
        case 'google/sentiment/v1':
          return Sentiment;
        case 'google/vision/v1':
          return Eye;
        default:
          return GoogleDrive;
      }
    case 'i9-advantage':
      return I9Advantage;
    case 'jira':
      return Jira;
    case 'jobdiva':
      return JobDiva;
    case 'images':
      return Images;
    case 'invoices':
      return Invoices;
    case 'kafka':
      return Kafka;
    case 'lever':
      return Lever;
    case 'list':
      return List;
    case 'mediaocean-prisma':
      return MediaoceanPrisma;
    case 'netsuite':
      return Netsuite;
    case 'numbers':
      return Numbers;
    case 'okta':
      return Okta;
    case 'oracle':
      return Oracle;
    case 'oracle-sales-cloud':
      return OracleSalesCloud;
    case 'outlook':
      return Outlook;
    case 'dynamics':
      return MicrosoftDynamics;
    case 'parse':
      return LocationOn;
    case 'paylocity':
      return Paylocity;
    case 'pdf':
      return Pdf;
    case 'pipedrive':
      return Pipedrive;
    case 'powerpoint':
      return PowerPoint;
    case 'powerbi':
      return PowerBI;
    case 'pushbot':
      switch (appID) {
        case 'pushbot/make-prediction/v1':
          return Handlebars;
        case 'pushbot/set-text-field/v1':
          return Handlebars;
        case 'pushbot/set-decimal-value/v1':
          return Handlebars;
        case 'pushbot/set-integer-value/v1':
          return Handlebars;
        default:
          return Pushbot;
      }
    case 'quickbooks':
      return Quickbooks;
    case 's3':
      return S3;
    case 'salesforce':
      return Salesforce;
    case 'sap-successfactors':
      return SuccessFactors;
    case 'sftp':
      switch (appID) {
        case 'sftp/upload/v1':
        case 'sftp/upload/v2':
          return CloudUpload;
        case 'sftp/download/v1':
        case 'sftp/download/v2':
          return CloudDownload;
        default:
          return CloudUpload;
      }
    case 'service-now':
      return ServiceNow;
    case 'singleSignOn':
      return Sso;
    case 'slack':
      return Slack;
    case 'sharepoint':
      return Sharepoint;
    case 'sms':
      return Message;
    case 'sterling':
      return Sterling;
    case 'stripe':
      return Stripe;
    case 'table':
      return NavDataMagnetic;
    case 'tables':
      return NavDataMagnetic;
    case 'text':
      return Text;
    case 'trello':
      return Trello;
    case 'uipath':
      return UiPath;
    case 'web-api':
      return Api;
    case 'word':
      return Word;
    case 'workday':
      return Workday;
    case 'xml':
      return Xml;
    case 'youtube':
      return YouTube;
    case 'zendesk':
      return Zendesk;
    case 'zoom':
      return Zoom;
    case 'scheduled':
      return Calendar;
    case 'web':
      return Public;
    case 'webhook':
      return Api;
    case 'wrike':
      return Wrike;
    case 'webform':
    case 'triggers': // TODO: Clean this up, should only be "webform"
    case 'browser-automation':
      return Web;
    case 'manual':
      return ManualStart;
    default:
      return Trigger;
  }
}

export const appNameFromAppID = appID => appID.slice(0, appID.indexOf('/'));

export function makeConsistentName(appName, displayName) {
  return displayName.includes(': ')
    ? displayName
    : `${upperFirst(appName)}: ${displayName}`;
}



// WEBPACK FOOTER //
// ./js/util/integrations.js